import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { MessageSquare } from "lucide-react";

// Norwegian mobile (8 digits, starts with 4/9) or any international +number. Returns E.164 or null.
export function normalizePhone(raw) {
  let p = String(raw || "").replace(/[\s\-().]/g, "");
  if (p.startsWith("00")) p = `+${p.slice(2)}`;
  if (/^[49]\d{7}$/.test(p)) return `+47${p}`;
  if (/^\+47[49]\d{7}$/.test(p)) return p;
  if (/^\+(?!47)\d{8,15}$/.test(p)) return p;
  return null;
}

const template = (name, job) =>
  `Hei${name ? ` ${name}` : ""}! Dette er Bergen Kaffemaskin- og Teknikk Service${job ? ` angående ${job}` : ""}. \n\nMed vennlig hilsen\nBergen Kaffemaskin- og Teknikk Service, tlf 90 23 22 06`;

export default function SmsButton({ phone, name, jobCode, size = "sm", tid = "" }) {
  const num = normalizePhone(phone);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const start = () => { setText(template(name, jobCode)); setOpen(true); };
  const desktop = async () => {
    try { await navigator.clipboard.writeText(`${num}\n\n${text}`); toast.success("Номер и текст скопированы"); } catch { toast.error("Не удалось скопировать — скопируйте вручную"); }
    window.open("https://messages.google.com/web/conversations/new", "_blank", "noopener");
  };
  return (
    <>
      <Button type="button" size={size} disabled={!num} onClick={start} title={num ? num : "Нет корректного номера телефона"}
        className="bg-emerald-700 hover:bg-emerald-600 text-white gap-1.5" data-testid={`sms-open-btn${tid ? `-${tid}` : ""}`}>
        <MessageSquare className="h-4 w-4" />{num ? "Отправить SMS" : "SMS: нет номера"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-slate-800 border-slate-700 text-slate-100 max-w-lg" data-testid="sms-dialog">
          <DialogHeader>
            <DialogTitle>SMS клиенту {name || ""}</DialogTitle>
            <DialogDescription className="text-slate-400">Получатель: <b className="text-white" data-testid="sms-number">{num}</b>. Проверьте текст перед отправкой.</DialogDescription>
          </DialogHeader>
          <Textarea rows={6} value={text} onChange={(e) => setText(e.target.value)} className="bg-slate-900 border-slate-600 text-slate-100" data-testid="sms-text" />
          <div className="flex flex-col sm:flex-row gap-2">
            <a href={`sms:${num}?body=${encodeURIComponent(text)}`} data-testid="sms-phone-link"
              className="flex-1 text-center px-3 py-2 rounded bg-emerald-700 hover:bg-emerald-600 text-white text-sm">Открыть на телефоне (Google Messages)</a>
            <button type="button" onClick={desktop} data-testid="sms-desktop-btn"
              className="flex-1 px-3 py-2 rounded bg-slate-700 hover:bg-slate-600 text-white text-sm">На компьютере: Messages for web</button>
          </div>
          <p className="text-xs text-slate-400">Сообщение отправляете вы сами в Google Messages — система ничего не отправляет автоматически и не отмечает SMS как отправленное. На компьютере номер и текст копируются; вставьте их в «Начать чат» (телефон должен быть связан с messages.google.com).</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
